"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFullscreenOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.fullscreen_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "fullscreen_outline_svg__transparent_box" },
            React.createElement("path", { className: "fullscreen_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "fullscreen_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "fullscreen_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M20 4v2h4.58l-6.31 6.29 1.41 1.42L26 7.41V12h2V4zm6 2zM24.58 26H20v2h8v-8h-2v4.59l-6.32-6.3-1.41 1.42M12 6V4H4v8h2V7.42l6.29 6.29 1.42-1.42L7.41 6zM6 6zM12.27 18.29L6 24.58V20H4v8h8v-2H7.41l6.28-6.29-1.42-1.42z" }))));
}
exports.default = SvgFullscreenOutline;
//# sourceMappingURL=FullscreenOutline.js.map